import { render, staticRenderFns } from "./TituloDescontos.vue?vue&type=template&id=1557c0b8&"
import script from "./TituloDescontos.vue?vue&type=script&lang=js&"
export * from "./TituloDescontos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports